import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { FormBuilderComponent } from '@module-instance/form-builder-modal/form-builder/form-builder.component';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoFormModule } from '@shared/modules';

@Component({
  selector: 'app-form-builder-modal',
  templateUrl: './form-builder-modal.component.html',
  styleUrl: './form-builder-modal.component.scss',
  imports: [CipoFormModule, MatDialogModule, TranslateModule, FormBuilderComponent, CipoDialogHeaderComponent],
})
export class FormBuilderModalComponent {
  onSave() {
    // save form
  }
}
